import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentCard = ({ document, onDownload, onShare, onView }) => {
  const getDocumentIcon = (type) => {
    const icons = {
      invoice: 'FileText',
      warranty: 'Shield',
      report: 'ClipboardList',
      certificate: 'Award'
    };
    return icons?.[type] || 'File';
  };

  const getDocumentColor = (type) => {
    const colors = {
      invoice: 'text-primary',
      warranty: 'text-success',
      report: 'text-warning',
      certificate: 'text-accent'
    };
    return colors?.[type] || 'text-muted-foreground';
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024)?.toFixed(1) + ' KB';
    return (bytes / (1024 * 1024))?.toFixed(1) + ' MB';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0 ${getDocumentColor(document?.type)}`}>
          <Icon name={getDocumentIcon(document?.type)} size={20} />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1 truncate">
            {document?.name}
          </h4>
          <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground mb-3">
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={12} />
              {formatDate(document?.date)}
            </span>
            <span>•</span>
            <span>{formatFileSize(document?.size)}</span>
            <span>•</span>
            <span className="uppercase">{document?.format}</span>
          </div>
          
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              size="xs"
              iconName="Eye"
              onClick={() => onView(document?.id)}
            >
              Voir
            </Button>
            <Button
              variant="ghost"
              size="xs"
              iconName="Download"
              onClick={() => onDownload(document?.id)}
            >
              Télécharger
            </Button>
            <Button
              variant="ghost"
              size="xs"
              iconName="Share2"
              onClick={() => onShare(document?.id)}
            >
              Partager
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;